import type { Job } from "@core/domains/jobs";

export function getJobsQueryKey({
  resourceId,
  type,
}: Pick<Job, "resourceId" | "type">): readonly unknown[] {
  return ["jobs", type, resourceId];
}
